import script from "./TheLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./TheLogin.vue?vue&type=script&setup=true&lang=js"

import "./TheLogin.vue?vue&type=style&index=0&id=2cfe9e1c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cfe9e1c"]])

export default __exports__